import * as React from 'react';
const SvgGallery = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M4.5 15.5h2.135a.527.527 0 0 1 .541.538.53.53 0 0 1-.155.387.52.52 0 0 1-.386.159H4.087a.65.65 0 0 1-.478-.193.65.65 0 0 1-.192-.477v-2.548a.527.527 0 0 1 .537-.542q.23 0 .387.156a.52.52 0 0 1 .16.386zm11.008 0v-2.134a.526.526 0 0 1 .538-.542.53.53 0 0 1 .545.542v2.548q0 .285-.192.477a.65.65 0 0 1-.478.193h-2.548a.53.53 0 0 1-.385-.155.52.52 0 0 1-.156-.383q0-.228.156-.387a.52.52 0 0 1 .385-.159zM4.5 4.5v2.135a.526.526 0 0 1-.537.542.53.53 0 0 1-.388-.156.52.52 0 0 1-.158-.386V4.087q0-.285.192-.477a.65.65 0 0 1 .478-.193h2.548a.526.526 0 0 1 .541.537.53.53 0 0 1-.155.388.52.52 0 0 1-.386.158zm11.008 0h-2.135a.53.53 0 0 1-.385-.154.52.52 0 0 1-.156-.383q0-.23.156-.387a.52.52 0 0 1 .385-.159h2.549q.284 0 .477.193a.65.65 0 0 1 .192.477v2.548a.527.527 0 0 1-.537.542.53.53 0 0 1-.387-.156.52.52 0 0 1-.159-.386z'
            />
        </g>
    </svg>
);
export default SvgGallery;
